import _ from "lodash"
import { useEffect, useState } from "react"

const MODULE_KEY = "SCHEME_MANAGEMENT"

const useSchemeBanners = (pwaConfig) => {
  const [bannerImg, setBannerImg] = useState()
  const [footerImg, setFooterImg] = useState()

  useEffect(() => {
    const modules = _.get(pwaConfig, "appConfig.config.modules", {})

    if (_.get(pwaConfig, "appConfig.config.notForAllPage") === "false") {
      setBannerImg(_.get(modules, "FOR_ALL_PAGE.headerImage"))
      setFooterImg(_.get(modules, "FOR_ALL_PAGE.footerImage"))
      return
    }

    setBannerImg(
      _.get(modules, `${MODULE_KEY}.headerImage`) ||
        _.get(modules, "FOR_ALL_PAGE.headerImage")
    )
    setFooterImg(
      _.get(modules, `${MODULE_KEY}.footerImage`) ||
        _.get(modules, "FOR_ALL_PAGE.footerImage")
    )
  }, [pwaConfig])

  return { bannerImg, footerImg }
}

export default useSchemeBanners
